import React, { Component } from "react";

export default class LachakToranjTabCornerItem extends Component {
  render() {
    return (
      <li
        className={
          this.props.activePartsTab === "corner" ? "active" : ""
        }
        onClick={() => {
          this.props.partsTabHandler("corner");
        }}
      >
        <svg width="100%" height="100%" viewBox="0 0 34 23" version="1.1">
          <g transform="matrix(1,0,0,1,-3083.97,-3165.69)">
            <g transform="matrix(1,0,0,1,-4870.89,3017.25)">
              <g transform="matrix(0.0399722,0,8.11535e-34,0.04245,7936.4,132.335)">
                <rect
                  x="474.416"
                  y="391.142"
                  width="807.127"
                  height="506.676"
                  style={{
                    fill: "rgb(222,42,53)",
                    stroke: "white",
                    strokeWidth: "24.25px"
                  }}
                />
              </g>
            </g>
            <g transform="matrix(1,0,0,1,-4870.89,3017.25)">
              <g transform="matrix(0.0398966,-4.05768e-34,0,0.0398423,7939.62,135.545)">
                <path
                  d="M1203.22,875.484L1007.31,875.484L1203.22,679.569L1203.22,875.484ZM395.673,678.466L395.673,874.381L591.588,874.381L395.673,678.466ZM1204.33,533.216L1008.41,337.301L1204.33,337.301L1204.33,533.216ZM394.569,532.112L394.569,336.198L590.484,336.198L394.569,532.112Z"
                  style={{
                    fill: "white",
                    stroke: "white",
                    strokeWidth: "25.08px"
                  }}
                />
              </g>
            </g>
          </g>
        </svg>
        <span>{this.props.texts["corner"]}</span>
      </li>
    );
  }
}
